import Grid from '@mui/material/Grid';
import { useFormikContext } from 'formik';
import { NEW_NON_EMPLOYEE_KEYS } from 'pages/NewNonEmployee/_const';
import SelfSponsor from 'pages/NewNonEmployee/components/fields/SelfSponsor';
import SponsorSelect from 'pages/NewNonEmployee/components/fields/SponsorSelect';
import SiteAdminRoleCheck from '../../components/views/SiteAdminRoleCheck';

const SponsorFieldsContainer = ({ label }) => {
	const { values } = useFormikContext();
	return (
		<SiteAdminRoleCheck
			name={NEW_NON_EMPLOYEE_KEYS.REQUESTOR_IS_SITE_ADMIN}
		>
			<Grid item xs={12}>
				<SelfSponsor labelUsernameType={label} />
			</Grid>

			{values[NEW_NON_EMPLOYEE_KEYS.SELF_SPONSOR] === 'false' && (
				<Grid item xs={12}>
					<SponsorSelect
						name={NEW_NON_EMPLOYEE_KEYS.SPONSOR}
						key={NEW_NON_EMPLOYEE_KEYS.SPONSOR}
					/>
				</Grid>
			)}
		</SiteAdminRoleCheck>
	);
};

export default SponsorFieldsContainer;
